const timestamp = Date.now();

function getAccessTimeUrl(url: string): string {
  return `${url}?accessTime=${timestamp}`
}

export default getAccessTimeUrl;
